import { useContext } from "react";

import { HeaderMenuContext } from "../contexts/header-menu";

export function useHeaderMenu() {
  return useContext(HeaderMenuContext)!;
}
